import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';



const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: 500,
      height: 200,
    },
    titleBar: {
      background:
        'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
        'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
      color: 'white',
    },
  }));

export default function PostImage(props) {

  const handleChanges = (index) => {
     props.romoveImage(index)
  };
  let  tileData  = [];
  for (let i = 0; i < (props.images.length); i++) { 
    let sinle_image = { key  : i,
                        img  : props.images[i],
                        type : props.images[i].includes('video') ? 'VIDEO' : 'IMAGE',
                        title: 'Image'
                       };
    tileData.push( sinle_image );
  }

  const classes = useStyles();
  return (
    <div className={classes.root}>
       <GridList cellHeight={160} className={classes.gridList} cols={3}>
        {tileData.map((tile,index) => (
          <GridListTile key={tile.key} cols={tile.cols || 1} >
             {
               tile.type == 'VIDEO' ?
               <video controls className="chat_media" src={tile.img} controlsList="nodownload"></video> 
               :  <img src={tile.img} alt={tile.title} />
             }
            
            <GridListTileBar
              titlePosition="top"
              actionIcon={
                <IconButton aria-label={`star ${tile.title}`} className={classes.icon} onClick={() =>  handleChanges(index)}>
                  <HighlightOffIcon />
                </IconButton>
              }
              actionPosition="right"
              className={classes.titleBar}
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}
